import React from 'react'
import { cloneProjectunit } from '../../store/actions/index';
import ProjectunitModal from './ProjectunitModal';

const CloneProjectunitModal = (props) => {

  const unit = props.formObject;

  const onSubmitAction = (values) => {
    return cloneProjectunit(values.title, values.description, values.description_long, values.notice, unit.id)
  };

  const modalTitle = "Bauabschnitt kopieren";

  const initialValues = { title: unit.title,
      description: unit.description,
    };

  return (

    <ProjectunitModal
      modalTitle={modalTitle}
      onSubmitAction={onSubmitAction}
      initialValues={initialValues}
    />
  )
}

export default CloneProjectunitModal



// WEBPACK FOOTER //
// ./src/components/Modals/CloneProjectunitModal.js